import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {
  Row,
  Col,
  Icon,
  Grid,
  Table,
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
  PanelContainer,
  Radio,
  Checkbox,
  FormGroup,
  InputGroup,
  ControlLabel,
  Button,
  Form,
  FormControl,
  Well,
} from '@sketchpixy/rubix';
import _ from 'lodash';

import {
    getClinicianList,
    getPatientListForMapping,
    getPatientClinicianMapping,
    mapClinicianToPatients,
    getServiceRegion, deleteMessageCode,
} from '../../../api/api';
import RoleType from '../../RoleGroup/Roles/RoleType';
import {checkRole} from '../../../util/RoleChecker';
import {routeUrl} from '../../routeUrl';

const CHECKED_BUTTON_ICON = 'icon-fontello-check-3';
const UNCHECKED_BUTTON_ICON = 'icon-fontello-check-empty-1';
const REGION_ALL = null;

export default class ClinicianDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      patients: [],
      clinicianId: null,
      roleRegion: REGION_ALL,
      serviceRegions: [],
      search: {
          country: REGION_ALL,
          query: '',
          gender: ''
      }
    };
  }

  componentWillReceiveProps() {
      if(this.props.clinicianId === null) return;
      this.initClinicianDetail();
  }

  componentDidMount() {
      if(this.props.clinicianId === null) return;
      this.initClinicianDetail();
  }

  initClinicianDetail()
  {
      const clinicianId = parseInt(this.props.clinicianId);

      this.setState({
          clinicianId
      },() => {
          this.doInitClinicianDetail();
      });
  }

  doInitClinicianDetail()
  {
      let self = this;

        Messenger.options = {
          theme: 'flat',
        };

        const requiredRoles = [
          RoleType.CLINICIAN_PATIENT_MAPPING,
          RoleType.CLINICIAN_PATIENT_MAPPING_READ_ONLY,
        ];

        checkRole(requiredRoles, this.props.router);

        let roles = JSON.parse(localStorage.getItem('roles'));
        let roleRegion = null;

        requiredRoles.forEach(requiredRoleType => {
          roles.forEach(role => {
            if (role.roleType && RoleType.enumValueOf(role.roleType.name) === requiredRoleType) {
              roleRegion = role.region;
            }
          });
        });

        this.setState({
            roleRegion,
            search: {country: (roleRegion === 'ALL' ? '' : roleRegion)}
          });

        getServiceRegion((err, result) => {
          if (err) {
            this.props.router.push(routeUrl.login);
          } else {
            this.setState({
              serviceRegions: result.list,
            });
          }
        });

        let datatables =  this.initPatientTable();
        let selectedPatientsTables =  this.initSelectedPatientTable();

        getPatientClinicianMapping(self.state.clinicianId, (err, res) => {
            selectedPatientsTables.clear();
            selectedPatientsTables.rows.add(res.patients);
            selectedPatientsTables.draw();

            this.setState({
                datatables,
                selectedPatientsTables
            },() => {
                self.doSearch();
            });
         });
  }
  initPatientTable()
  {
      let self = this;
      let datatableDom = $(ReactDOM.findDOMNode(this.refs.patientsTables));
      if ($.fn.DataTable.isDataTable(datatableDom ) ) {
          return this.state.datatables;
      }

      let datatables = datatableDom.addClass('nowrap')
          .DataTable({
        	  language: { infoFiltered: "" },
            processing: true,
            serverSide: true,
            responsive: true,
            searchDelay: 2000,
            searching: false,
            ajax : function (data, callback, settings) {
               let search = self.state.search;
               let param = _.merge({}, data, search)
               getPatientListForMapping(param, (err, res) => {
                 self.setState({ patients: res.patients });
                 callback(res.patients);
               });
            },
            columns: [
                {
                  name: 'patientDto.patientFirstName',
                  data: 'patientDto.patientFirstName',
                  defaultContent : "",
                  render: function ( data, type, row ) {
                      let patient = row.patientDto;
                      let name  = patient.patientNickname ? patient.patientNickname : `${patient.patientFirstName} ${patient.patientLastName}`;
                      return name.length > 20 ? name.substr( 0, 20 ) +'…' : name;
                  }
                },
                {
                  name: 'userDto.userEmail',
                  data: 'userDto.userEmail',
                  defaultContent : ""
                },
                {
                    name: 'patientDto.patientGender',
                    data: 'patientDto.patientGender',
                    defaultContent : "",
                    render: function ( data, type, row ) {
                        if(data) {
                            let str = data.toLowerCase()
                            return str.charAt(0).toUpperCase() + str.slice(1);
                        } else return ""
                    }
                },
                {
                    name: 'patientDto.countryDto.countryAlpha3Code',
                    data: 'patientDto.countryDto.countryAlpha3Code',
                    defaultContent : ""
                },
                {
                  name: 'actions',
                  data: 'patientId',
                  orderable: false,
                  defaultContent : "",
                  render: function (patientId, type, row) {
                    let buttons = '';

                    buttons +="<Button class='btn btn-info'  data-id='"+patientId+"' data-action='SELECT'>Select</Button>"; //수정

                    return buttons;
                  }
                },
            ],
            rowId: 'patientId',
            select: true
        });

        datatableDom.find('tbody').on('click', 'button',  function (event) {
          //선택된 환자
          let patientId = $(event.target).data("id");
          let patientUser = self.state.patients.data.find(function(patient) {
            return patient.patientId === patientId;
          });

          //이미 선택된 환자 인지 검사
          let selectedPatientsTables = self.state.selectedPatientsTables;

          let data = selectedPatientsTables.rows().data();

          for(let idx = 0; idx < data.length; idx++)
          {
            if(data[idx].patientId === patientId)
            {
              return Messenger().post({
                      type: 'error',
                      message: `Already selected user!`,
                      showCloseButton: true,
              });
            }
          }

          let action = $(event.target).data("action");
          switch(action)
          {
              case 'SELECT':
                selectedPatientsTables.row.add(patientUser).draw(false);
              break;
          }
        });

        return datatables;
  }

  initSelectedPatientTable()
  {
      let self = this;
      let datatableDom = $(ReactDOM.findDOMNode(this.refs.selectedPatientsTables));
      if ($.fn.DataTable.isDataTable(datatableDom ) ) {
          return this.state.selectedPatientsTables;
      }
      let datatables = datatableDom.addClass('nowrap')
          .DataTable({
            language: { infoFiltered: "" },
            processing: true,
            serverSide: false,
            responsive: true,
            searchDelay: 2000,
            searching: false,
            columns: [
                {
                  name: 'patientDto.patientFirstName',
                  data: 'patientDto.patientFirstName',
                  defaultContent : "",
                  render: function ( data, type, row ) {
                      let patient = row.patientDto;
                      let name  = patient.patientNickname ? patient.patientNickname : `${patient.patientFirstName} ${patient.patientLastName}`;
                      return name.length > 20 ? name.substr( 0, 20 ) +'…' : name;
                  }
                },
                {
                  name: 'userDto.userEmail',
                  data: 'userDto.userEmail',
                  defaultContent : ""
                },
                {
                  name: 'actions',
                  data: 'patientId',
                  orderable: false,
                  defaultContent : "",
                  render: function (patientId, type, row) {
                    let buttons = '';

                    buttons +="<Button class='btn btn-info'  data-id='"+patientId+"' data-action='DELETE'>Remove</Button>"; //수정

                    return buttons;
                  }
                },
            ],
            rowId: 'patientId',
            select: true
        });

        datatableDom.find('tbody').on('click', 'button',  function (event) {
          let patientId = $(event.target).data("id");
          let action = $(event.target).data("action");

          switch(action)
          {
              case 'DELETE':
                  let selectedPatientsTables = self.state.selectedPatientsTables;

                  selectedPatientsTables.rows( function ( idx, data, node ) {
                      return data.patientId === patientId;
                  }).remove().draw(false);
              break;
          }
        });

        return datatables;
  }

  doSearch = () => {
      this.state.datatables.ajax.reload();
  }

  saveButtonClickHandler = () => {
    let self = this;
    const clinicianId = this.state.clinicianId;
    if (!clinicianId) {
      return Messenger().post({
        type: 'error',
        message: `Select clinician at least 1.`,
        showCloseButton: true,
      });
    }

    let selectedPatientsTables = this.state.selectedPatientsTables;
    let data = selectedPatientsTables.rows().data();
    let patientIds = [];
    for(let idx = 0; idx < data.length; idx++)
    {
      patientIds.push(data[idx].patientId);
    }

      vex.dialog.confirm({
          message: 'If the selected patient is already assigned to another clinician, that information will be lost?',
          callback: function (beConfirmed) {
              if(!beConfirmed) return

              mapClinicianToPatients(clinicianId, patientIds, (err, result) => {
                  if (err) {
                      Messenger().post({
                          type: 'error',
                          message: `${err.message} (${err.statusCode})`,
                          showCloseButton: true,
                      });
                  } else {
                      getPatientClinicianMapping(self.state.clinicianId, (err, res) => {
                          selectedPatientsTables.clear();
                          selectedPatientsTables.rows.add(res.patients);
                          selectedPatientsTables.draw();
                      });

                      Messenger().post({
                          type: 'success',
                          message: 'Saved Successfully.',
                          showCloseButton: true,
                      });
                  }
              });
          }
      });
  };

  patientCountryChangeHandler = (event) => {
    let country = event.target.value === 'ALL' ? '' : event.target.value;
    this.setState({
       search: {...this.state.search, country: country},
    });
  };

  queryChangeHandler = (event) => {
    let query = event.target.value;
    this.setState({
      search: {...this.state.search, query: query},
    });
  };

  genderChangeHandler = (event) => {
    let gender = event.target.value === 'ALL' ? '' : event.target.value;
    this.setState({
      search: {...this.state.search, gender: gender},
    });
  };

  render() {
    return (
          <Row>
          <Col sm={6}>
          <PanelContainer controls={false}>
            <Panel>
              <PanelHeader style={{padding: 0}}>
                <Grid>
                  <Row>
                    <Col xs={12}>
                      <h3>Patient list</h3>
                      <Well>
                      <Form inline>
                        <FormGroup controlId="patientCountrySelect">
                          <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Country</ControlLabel>
                          <FormControl
                              onChange={this.patientCountryChangeHandler}
                              componentClass="select"
                              style={{width: '120px'}}
                          >
                            <option value={null}>ALL</option>
                            {
                              this.state.serviceRegions.map(serviceRegion => (
                                  <option key={serviceRegion.countryId} value={serviceRegion.countryAlpha2Code}>
                                    {serviceRegion.countryAlpha3Code}
                                  </option>
                              ))
                            }
                          </FormControl>
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Gender</ControlLabel>
                          <FormControl
                            onChange={this.genderChangeHandler}
                            componentClass="select"
                            style={{width: '120px'}}
                          >
                          <option value={null}>ALL</option>
                          <option value='MALE'>Male</option>
                          <option value='FEMALE'>Female</option>
                          <option value='OTHER'>Other</option>    
                          </FormControl>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel style={{width: '120px', paddingLeft: '10px'}}>Search Word</ControlLabel>
                            <FormControl type='text' placeholder='Search Word' onChange={this.queryChangeHandler}/>
                        </FormGroup>
                        <FormGroup className="pull-right">
                            <InputGroup.Button>
                                <Button onClick={this.doSearch}>Search</Button>
                            </InputGroup.Button>
                        </FormGroup>
                      </Form>
                    </Well>
                    </Col>
                  </Row>
                </Grid>
              </PanelHeader>
              <PanelBody style={{padding: 0}}>
                  <Table ref="patientsTables" className='display' cellSpacing='0' width='100%'>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Gender</th>
                      <th>Country</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                </Table>
              </PanelBody>
            </Panel>
          </PanelContainer>
        </Col>
            <Col sm={6}>
              <PanelContainer controls={false}>
                <Panel>
                  <PanelHeader>
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <h3>Selected Patient</h3>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelHeader>
                  <PanelBody style={{padding: 0}}>
                      <Table ref="selectedPatientsTables" className='display' cellSpacing='0' width='100%'>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                    </Table>
                  </PanelBody>
                  <PanelFooter>
                      <Row>
                          <Col xs={12}>
                            <div style={{marginTop: '15px', marginBottom: '15px', float: 'right'}}>
                              <Button bsStyle='brownishgray' onClick={this.props.showListHandler} style={{marginRight: '8px'}}>List</Button>
                              <Button bsStyle='brownishgray' onClick={this.saveButtonClickHandler} style={{marginRight: '8px'}}>Save</Button>
                            </div>
                          </Col>
                      </Row>
                  </PanelFooter>
                </Panel>
              </PanelContainer>
            </Col>
          </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/cp-mapping/components/ClinicianDetail.js